import { Centered, FlexColumn, FlexRow, StyledButton } from '@gorila-shared-ui/components';
import { HeadingMedium, HeadingXSmall } from 'baseui/typography';
import { useStyles } from '../../hooks/useStyles';
import { StyledRouterLink } from '../ui/StyledRouterLink';

function Error404Page() {
  const { theme, css } = useStyles();

  return (
    <Centered>
      <FlexColumn classNames={css({ maxWidth: '350px' })} gap={theme.sizing.scale700}>
        <FlexRow centered>
          <img
            src={'/img/logo_circulo.svg'}
            alt="logo"
            className={css({
              height: '15vh',
            })}
          />
        </FlexRow>
        <FlexColumn gap={theme.sizing.scale100} centered classNames={css({ textAlign: 'center' })}>
          <HeadingMedium marginTop={theme.sizing.scale300} marginBottom={0} color={theme.colors.contentSecondary}>
            Error 404
          </HeadingMedium>
          <HeadingXSmall margin={0} color={theme.colors.contentSecondary}>
            No se encontró el contenido solicitado o no puede ser mostrado.
          </HeadingXSmall>
        </FlexColumn>
        <StyledButton>
          <StyledRouterLink to={'/'} color={theme.colors.white}>
            Inicio
          </StyledRouterLink>
        </StyledButton>
      </FlexColumn>
    </Centered>
  );
}

export default Error404Page;
